module.exports = __webpack_public_path__ + "img/type--2-spans--single-lang--en.1edf661b.jpg";